import { useState } from 'preact/hooks';
import { Check } from 'flowbite-react-icons/outline';
import PropTypes from 'prop-types';
import './color-picker.scss';
import { COLOR_VALUES } from '@data/colors.js';
import { formatColorName } from '@util/common.js';

const defaultFilterFunction = (color) => !!color;

export default function ColorPicker({
  onChange,
  currentColor,
  fieldName,
  filterFunction = defaultFilterFunction,
  allowMulti = false,
  lightColorsOnly = false,
}) {
  let colorInput;

  const [pickerState, setPickerState] = useState({
    color: currentColor,
  });

  const changeColor = (color) => {
    setPickerState({ color });
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    ).set;

    nativeInputValueSetter.call(colorInput, color);

    const event = new Event('input', { bubbles: true });
    colorInput.dispatchEvent(event);
  };

  let validColors = allowMulti ? ['multi', ...COLOR_VALUES] : COLOR_VALUES;

  if (lightColorsOnly)
    validColors = validColors
      .filter((color) => !color.includes('dark'))
      .map((color) => color.replace('light-', ''));

  const isLightGray = currentColor === 'light-grey'

  const colorOptions = validColors.filter(filterFunction).map((color) => {
    if (color === currentColor)
      return (
        <button
          key={color}
          onClick={() => changeColor(color)}
          className={`h-10 w-10 flex border-2 justify-center content-center shadow-xl ${isLightGray ? 'text-neutral-600' : 'text-white'} items-center rounded color-picker-${color} mr-2`}
        >
          <Check />
        </button>
      );
    else
      return (
        <div key={color} data-tip={formatColorName(color)} className="tooltip">
          <button
            onClick={() => changeColor(color)}
            className={`h-10 w-10 border-2 rounded color-picker-${color} mr-2`}
          ></button>
        </div>
      );
  });

  return (
    <>
      <div className="flex flex-wrap md:flex-nowrap mt-1 mb-3">
        <input
          className="hidden"
          name={fieldName}
          value={pickerState.color}
          onChange={onChange}
          ref={(input) => (colorInput = input)}
        />
        {colorOptions}
      </div>
    </>
  );
}

ColorPicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  currentColor: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  filterFunction: PropTypes.func,
  allowMulti: PropTypes.bool,
  lightColorsOnly: PropTypes.bool,
};
